import type { TMessages } from '@/types/TMessages'

export const messages = {
  leasingMessage: 'Для покупки техники изучите предложения лизинга',
  increaseLoanAmountBanner: {
    comment: 'Заявка на отчет из раздела "Кредиты и лизинг"',
  },
} satisfies TMessages
